import {Component, inject} from '@angular/core';
import {MatCard, MatCardContent, MatCardFooter} from '@angular/material/card';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from '../../../../services/auth.service';
import {passwordComplexityValidator} from '../../../../shared/validators/password-complexity.validator';
import {matchValidator} from '../../../../shared/validators/match.validator';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatError, MatFormField, MatHint, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'tgrid-reset-password',
  imports: [
    MatCard,
    MatCardContent,
    MatCardFooter,
    ReactiveFormsModule,
    MatFormField,
    MatError,
    MatLabel,
    MatHint,
    MatInput,
    MatButton,
  ],
  templateUrl: './reset-password.component.html',
  standalone: true,
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {

  private router = inject(Router);
  private authService = inject(AuthService);
  private formBuilder = inject(FormBuilder);
  private popup = inject(MatSnackBar);

  resetGroup = this.formBuilder.group({
    password: ['', {nonNullable: true, validators: [Validators.required], asyncValidators: [passwordComplexityValidator(this.authService)]}],
    confirmPassword: ['', {nonNullable: true, validators: [Validators.required]}],
  }, {
    validators: matchValidator('password', 'confirmPassword'),
  });

  changePassword() {
    if (this.resetGroup.invalid) {
      return;
    }

    const password = this.resetGroup.controls.password.value as string;
    this.authService.resetPasswordFromCode(password).subscribe({
      next: () => {
        this.popup.open('Your password has been changed. Redirecting to login...', '', {
          panelClass: 'success',
          duration: 2500,
        });
        window.setTimeout(() => this.router.navigate(['/login']), 2500);
      },
      error: (error) => {
        console.error(error);
        this.errorPopup();
      },
    });
  }

  private errorPopup() {
    this.popup
      .open('There was an error changing your password. If the problem persists, email the admin for help.', 'Email', {
        panelClass: ['failure', 'popup-text'],
      })
      .onAction()
      .subscribe(() => {
        window.location.href = 'mailto:info@tasti-grid.gov';
      });
  }

}
